/* ripple+ Nootropic Pouches bundle builder (#pouch-builder).
   Forked from quit-kit.js: tiers + flavour steppers + one /cart/add.js call + Rebuy drawer.
   - On load each flavour gets its "Pre-selected quantity" (block order, capped at the tier size).
   - Steppers can never exceed the tier. Changing the tier never resets the pick: going down trims
     only the excess (most recently added first) and remembers it; going back up restores it.
   - The button always shows the tier price ("ADD 2 MORE FLAVOURS | $48 $40", "ADD TO CART | ...").
   - A flavour with no product (or a sold-out one) can be picked; the button still looks normal and
     only a click on it shows the message naming that flavour (nothing is added).
   - window CustomEvent('pouch-builder:tier', {detail:{size:6}}) selects a tier from elsewhere. */
(function () {
  'use strict';

  function qsa(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }

  function init(root) {
    if (!root || root.__pb) return;
    var cfgEl = root.querySelector('[data-pb-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    root.__pb = true;
    cfg.text = cfg.text || {};

    /* ---------- money: whole dollars print without cents ($40, not $40.00) ---------- */
    var fmts = {};
    function money(cents) {
      var dp = cents % 100 === 0 ? 0 : 2;
      if (!fmts[dp]) {
        try {
          fmts[dp] = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency', currency: cfg.currency || 'USD', minimumFractionDigits: dp, maximumFractionDigits: dp
          });
        } catch (e) {
          fmts[dp] = { format: function (n) { return '$' + n.toFixed(dp); } };
        }
      }
      return fmts[dp].format(cents / 100);
    }
    function esc(t) {
      return String(t).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    var tiers = cfg.tiers || [];
    var flavours = cfg.flavours || [];
    if (!tiers.length) return;

    var state = {
      tier: Math.min(Math.max(cfg.defaultTier || 0, 0), tiers.length - 1),
      qty: {},
      order: [],           /* one entry per can, in the order they were added */
      trimmed: []          /* cans a smaller tier took away, last trimmed on top */
    };

    var el = {
      tiers: qsa(root, '[data-pb-tier]'),
      rows: qsa(root, '[data-pb-fl]'),
      cta: root.querySelector('[data-pb-cta]'),
      ctaText: root.querySelector('[data-pb-cta-t]'),
      msg: root.querySelector('[data-pb-msg]'),
      fls: root.querySelector('.pb__fls')
    };

    function tier() { return tiers[state.tier]; }
    function size() { return tier().size; }
    function count() { return state.order.length; }
    function flavourById(id) {
      for (var i = 0; i < flavours.length; i++) if (flavours[i].id === id) return flavours[i];
      return null;
    }
    function sold(f) { return f && f.hasProduct && !f.available; }

    function tierNow(t) { return cfg.canPrice * Math.max(t.size - (t.free || 0), 0); }
    function tierWas(t) { return cfg.canPrice * t.size; }

    function fill(tpl, map) {
      return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
        return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
      });
    }
    function moreText(n) {
      return fill(cfg.text.more, { n: n, S: n === 1 ? '' : 'S', s: n === 1 ? '' : 's' });
    }
    function bundleLabel() {
      var t = tier();
      return t.free ? fill(cfg.text.bundle, { size: t.size, free: t.free }) : fill(cfg.text.bundleNoFree, { size: t.size, free: 0 });
    }

    /* selected flavours that can't be bought yet */
    function blockers() {
      var out = [];
      Object.keys(state.qty).forEach(function (id) {
        var f = flavourById(id);
        if (!f || !state.qty[id]) return;
        if (!f.hasProduct || !f.variant) out.push({ f: f, why: 'noProduct' });
        else if (!f.available) out.push({ f: f, why: 'soldOut' });
      });
      return out;
    }

    function showMsg(t) {
      if (!el.msg) return;
      el.msg.textContent = t || '';
      el.msg.classList.toggle('is-on', !!t);
    }

    /* fit the pick to the current tier: trim the newest cans (remembered), or restore trimmed ones */
    function clamp() {
      var max = size();
      var id;
      while (state.order.length > max) {
        id = state.order.pop();
        state.qty[id]--;
        if (state.qty[id] <= 0) delete state.qty[id];
        state.trimmed.push(id);
      }
      while (state.order.length < max && state.trimmed.length) {
        id = state.trimmed.pop();
        var f = flavourById(id);
        if (!f || sold(f)) continue;
        state.qty[id] = (state.qty[id] || 0) + 1;
        state.order.push(id);
      }
    }

    function add(id) {
      var f = flavourById(id);
      if (!f || sold(f) || count() >= size()) return;
      state.qty[id] = (state.qty[id] || 0) + 1;
      state.order.push(id);
    }
    function remove(id) {
      if (!state.qty[id]) return;
      state.qty[id]--;
      if (state.qty[id] <= 0) delete state.qty[id];
      var i = state.order.lastIndexOf(id);
      if (i > -1) state.order.splice(i, 1);
    }

    function render() {
      var max = size();
      var n = count();

      el.tiers.forEach(function (node) {
        var on = parseInt(node.getAttribute('data-pb-tier'), 10) === state.tier;
        node.classList.toggle('is-on', on);
        node.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      el.rows.forEach(function (row) {
        var id = row.getAttribute('data-pb-fl');
        var f = flavourById(id);
        var q = state.qty[id] || 0;
        var minus = row.querySelector('[data-pb-minus]');
        var plus = row.querySelector('[data-pb-plus]');
        var cnt = row.querySelector('[data-pb-cnt]');
        if (cnt) cnt.textContent = q;
        if (minus) minus.disabled = q === 0;
        if (plus) plus.disabled = n >= max || sold(f);
        row.classList.toggle('is-active', q > 0);
        row.classList.toggle('is-soldout', !!sold(f));
      });

      /* any change clears the last message; messages only ever come from a click on the button */
      showMsg('');
      if (!el.cta || !el.ctaText) return;
      var complete = n === max;
      el.cta.classList.toggle('is-incomplete', !complete);
      el.cta.setAttribute('aria-disabled', complete ? 'false' : 'true');
      var t = tier();
      var now = tierNow(t);
      var was = tierWas(t);
      el.ctaText.innerHTML = esc(complete ? (cfg.text.atc || 'ADD TO CART') : moreText(max - n)) + ' | ' +
        (was > now ? '<s class="pb__was">' + esc(money(was)) + '</s> ' : '') + esc(money(now));
    }

    function blockMsg(b) {
      var names = b.map(function (x) { return x.f.name; });
      var why = b.every(function (x) { return x.why === 'soldOut'; }) ? 'soldOut' : 'noProduct';
      var joined = names.length > 1 ? names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1] : names[0];
      return fill(cfg.text[why] || cfg.text.noProduct, { flavour: joined });
    }

    function selectTier(i) {
      if (i < 0 || i >= tiers.length) return;
      state.tier = i;
      clamp();
      render();
    }

    /* ---------- events ---------- */
    el.tiers.forEach(function (node) {
      node.addEventListener('click', function () {
        selectTier(parseInt(node.getAttribute('data-pb-tier'), 10) || 0);
      });
    });

    el.rows.forEach(function (row) {
      var id = row.getAttribute('data-pb-fl');
      var minus = row.querySelector('[data-pb-minus]');
      var plus = row.querySelector('[data-pb-plus]');
      if (plus) plus.addEventListener('click', function () { add(id); render(); });
      if (minus) minus.addEventListener('click', function () { remove(id); render(); });
    });

    /* another section (e.g. "CLAIM YOUR FREE CASE") picks a tier by size, then scrolls here */
    window.addEventListener('pouch-builder:tier', function (e) {
      var want = e && e.detail && parseInt(e.detail.size, 10);
      if (!want) return;
      for (var i = 0; i < tiers.length; i++) {
        if (tiers[i].size === want) { selectTier(i); return; }
      }
    });

    /* Open the cart where the shopper already is (same order as quit-kit.js). */
    function openCart() {
      if (cfg.redirect) { window.location.href = cfg.redirect; return; }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      try {
        if (window.Rebuy && window.Rebuy.SmartCart && typeof window.Rebuy.SmartCart.show === 'function') {
          window.Rebuy.SmartCart.show();
          return;
        }
      } catch (e) {}
      var trigger = document.querySelector('a.cart-link, [data-cart-toggle], .js-cart-trigger');
      if (trigger) { trigger.click(); return; }
      window.location.href = (cfg.routes && cfg.routes.cart) || '/cart';
    }

    function bundleId() {
      return 'pb-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
    }

    /* exposed for QA / other scripts: the exact body add to cart would send */
    function buildItems() {
      var id = bundleId();
      var label = bundleLabel();
      var items = [];
      flavours.forEach(function (f) {
        var q = state.qty[f.id];
        if (!q || !f.variant) return;
        /* the visible 'Bundle' line property is optional (blank setting = not added); the hidden _pouch_bundle id always is */
        var props = { _pouch_bundle: id };
        if (label && String(label).trim()) props.Bundle = label;
        items.push({ id: f.variant, quantity: q, properties: props });
      });
      return items;
    }

    if (el.cta) {
      el.cta.addEventListener('click', function (e) {
        e.preventDefault();
        if (el.cta.classList.contains('is-loading')) return;
        var left = size() - count();
        if (left > 0) {
          /* not full yet: point at the flavours instead of doing nothing */
          showMsg(fill(cfg.text.pick, { n: left }));
          if (el.fls) {
            el.fls.classList.remove('is-nudge');
            void el.fls.offsetWidth;
            el.fls.classList.add('is-nudge');
            var r = el.fls.getBoundingClientRect();
            if (r.top < 0 || r.top > window.innerHeight * 0.6) {
              try { el.fls.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { el.fls.scrollIntoView(); }
            }
          }
          return;
        }
        var b = blockers();
        if (b.length) { showMsg(blockMsg(b)); return; }
        var items = buildItems();
        if (!items.length) return;

        el.cta.classList.add('is-loading');
        fetch((cfg.routes && cfg.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
          .then(function (res) {
            el.cta.classList.remove('is-loading');
            if (!res.ok) throw new Error((res.body && (res.body.description || res.body.message)) || cfg.text.error);
            document.dispatchEvent(new CustomEvent('pouch-builder:added', { detail: { items: items, response: res.body } }));
            openCart();
          })
          .catch(function (err) {
            el.cta.classList.remove('is-loading');
            showMsg((err && err.message) || cfg.text.error);
          });
      });
    }

    /* pre-selection: block order, each flavour's "pre" cans, never past the tier (same as the Liquid first paint) */
    flavours.forEach(function (f) {
      var q = Math.max(0, parseInt(f.pre, 10) || 0);
      while (q-- > 0 && count() < size()) add(f.id);
    });

    root.pouchBuilder = { state: state, select: selectTier, add: add, remove: remove, render: render, items: buildItems };

    /* ---------- accordions: desktop may open one by default (pb-dopen), so read what's shown ---------- */
    qsa(root, '[data-pb-acc]').forEach(function (btn) {
      var item = btn.parentNode;
      var panel = item.querySelector('.pb__acc-p');
      function shown() { return panel && window.getComputedStyle(panel).display !== 'none'; }
      btn.setAttribute('aria-expanded', shown() ? 'true' : 'false');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = shown();
        item.classList.toggle('is-open', !open);
        item.classList.toggle('is-shut', open);
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    initGallery(root);
    initUgc(root);
    render();
  }

  /* ---------- gallery: native swipe, arrows loop, active slide's video plays ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-pb-track]');
    if (!track) return;
    var slides = qsa(track, '[data-pb-slide]');
    if (!slides.length) return;
    var thumbs = qsa(root, '[data-pb-thumb]');
    var current = 0;

    function mark() {
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === current ? 'true' : 'false'); });
    }

    function idx() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
    }
    function syncVideos() {
      slides.forEach(function (sl, i) {
        var v = sl.querySelector('video');
        if (!v) return;
        if (i === current) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else if (!v.paused) v.pause();
      });
    }
    var settling = 0;
    function goTo(i) {
      var n = slides.length;
      current = ((i % n) + n) % n;
      var left = slides[current].offsetLeft - slides[0].offsetLeft;
      settling = Date.now() + 700;
      try { track.scrollTo({ left: left, behavior: 'smooth' }); } catch (e) { track.scrollLeft = left; }
      setTimeout(function () { if (Math.abs(track.scrollLeft - left) > 4) track.scrollLeft = left; }, 400);
      mark();
      syncVideos();
    }
    var prev = root.querySelector('[data-pb-prev]');
    var next = root.querySelector('[data-pb-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx() - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-pb-thumb'), 10) || 0); });
    });

    var t = null;
    track.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (Date.now() < settling) return;   /* a thumb/arrow jump is still gliding past other slides */
        var i = idx();
        if (i !== current) { current = i; mark(); syncVideos(); }
      }, 80);
    }, { passive: true });
  }

  /* ---------- UGC strip: poster tiles, tap plays with sound, bar tracks the scroll ---------- */
  function initUgc(root) {
    var wrap = root.querySelector('[data-pb-ugc]');
    if (!wrap) return;
    var strip = wrap.querySelector('[data-pb-strip]');
    var bar = wrap.querySelector('[data-pb-bar]');
    var thumb = wrap.querySelector('[data-pb-bar-t]');
    var tiles = qsa(wrap, '[data-pb-ugc-tile]');

    function stopAll(except) {
      tiles.forEach(function (t) {
        if (t === except) return;
        var v = t.querySelector('video');
        if (v) {
          try { v.pause(); while (v.firstChild) v.removeChild(v.firstChild); v.removeAttribute('src'); v.load(); } catch (e) {}
          v.parentNode.removeChild(v);
        }
        t.classList.remove('is-playing');
      });
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (dragged) { e.preventDefault(); return; }
        var v = tile.querySelector('video');
        if (v) {
          if (v.paused) { var p0 = v.play(); if (p0 && p0.catch) p0.catch(function () {}); } else v.pause();
          return;
        }
        stopAll(tile);
        var list = [];
        try { list = JSON.parse(tile.getAttribute('data-src') || '[]'); } catch (x) {}
        if (!list.length) return;
        v = document.createElement('video');
        v.setAttribute('playsinline', '');
        v.playsInline = true;
        v.preload = 'auto';
        var img = tile.querySelector('img');
        if (img && img.currentSrc) v.poster = img.currentSrc;
        list.forEach(function (s) {
          var so = document.createElement('source');
          so.src = s.src; if (s.type) so.type = s.type;
          v.appendChild(so);
        });
        v.addEventListener('ended', function () { stopAll(null); });
        tile.appendChild(v);
        tile.classList.add('is-playing');
        v.muted = false;
        var p = v.play();
        if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
      });
    });

    function sync() {
      if (!strip || !thumb || !bar) return;
      var sw = strip.scrollWidth, cw = strip.clientWidth;
      var bw = bar.clientWidth;
      if (sw <= cw + 1) { thumb.style.width = bw + 'px'; thumb.style.transform = 'none'; return; }
      var tw = Math.max(24, bw * cw / sw);
      var p = strip.scrollLeft / (sw - cw);
      thumb.style.width = tw + 'px';
      thumb.style.transform = 'translateX(' + ((bw - tw) * p) + 'px)';
    }
    if (strip) {
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    }

    /* the bar is a scrubber: press / drag on it to move the strip */
    var dragged = false;
    if (bar && strip) {
      var active = false;
      function toPos(clientX) {
        var r = bar.getBoundingClientRect();
        var p = Math.max(0, Math.min(1, (clientX - r.left) / (r.width || 1)));
        strip.scrollLeft = p * (strip.scrollWidth - strip.clientWidth);
      }
      bar.addEventListener('pointerdown', function (e) {
        active = true; toPos(e.clientX);
        try { bar.setPointerCapture(e.pointerId); } catch (x) {}
      });
      bar.addEventListener('pointermove', function (e) { if (active) toPos(e.clientX); });
      bar.addEventListener('pointerup', function () { active = false; });
      bar.addEventListener('pointercancel', function () { active = false; });

      /* mouse drag on the strip itself (touch already swipes natively) */
      var down = null;
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = { x: e.clientX, left: strip.scrollLeft };
        dragged = false;
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - down.x;
        if (Math.abs(dx) > 5) dragged = true;
        if (dragged) strip.scrollLeft = down.left - dx;
      });
      window.addEventListener('pointerup', function () {
        if (!down) return;
        down = null;
        setTimeout(function () { dragged = false; }, 0);
      });
    }

    /* stop playback once the strip scrolls off screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (!en.isIntersecting) stopAll(null); });
      }, { threshold: 0 }).observe(wrap);
    }
  }

  function boot() { qsa(document, '[data-pb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { qsa(e.target, '[data-pb]').forEach(init); });
})();
